<template>
  <div class="metrics" :class="book.status.toLowerCase()">
    <div v-if="book.status === 'Available'">
      <div class="metric metric-reviews" v-if="book.stats.total_reviews">
        <div class="icon">
          <img src="/images/icons/reviews.svg" class="icon-reviews">
        </div>
        <div class="value">{{ book.stats.total_reviews }} reviews</div>
      </div>

      <div class="metric" v-if="book.stats.average_rating">
        <div class="icon">
          <img src="/images/icons/trend.svg" class="icon-trend">
        </div>
        <div
          class="value value-trending"
        >{{ parseFloat(Math.round( book.stats.average_rating) / 100).toFixed(1) }} avg rating</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Metrics",
  props: ["book"],
  data: function() {
    return {};
  },
  computed: {},
  mounted() {
    // console.log("metrics", this.book);
    //this.book.stats.in_progress_reviews = 2;
  }
};
</script>

<style lang="scss" scoped>
.metrics {
  padding-top: 8px;
}

.metric {
  float: left;
  display: flex;
  padding: 0 12px 0 0;
}

.icon {
}
.icon-reviews {
  margin-top: 7px;
  margin-left: 2px;
  margin-right: 4px;
  width: 26px;
  color: #ff5722;
}
.icon-trend {
  margin-left: 0px;
  margin-top: 6px;
  width: 25px;
  color: #ff5722;
}
.value {
  padding: 10px 1px;
  font-size: 12.5pt;
  font-weight: 600;
  color: $color-blue;
  font-family: $font-family;
}
.value-trending {
  color: darken(#66bb6a, 5%);
  padding-left: 6px;
}
</style>